import * as React from "react";
const SvgPerson = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 7a6.75 6.75 0 0 1 13.5 0v2a6.743 6.743 0 0 1-3 5.613v1.637h1.603a6.397 6.397 0 0 1 6.397 6.397c0 .61-.494 1.103-1.103 1.103H1.353c-.61 0-1.103-.494-1.103-1.103a6.397 6.397 0 0 1 6.397-6.397H8.25v-1.637A6.743 6.743 0 0 1 5.25 9V7Zm4.5 8.366v2.063a7.7 7.7 0 0 0 2.25.321 7.7 7.7 0 0 0 2.25-.322v-2.062a6.738 6.738 0 0 1-2.25.384 6.738 6.738 0 0 1-2.25-.384Zm-1.5 2.384H6.647a4.897 4.897 0 0 0-4.881 4.5h20.468a4.897 4.897 0 0 0-4.881-4.5H15.75v.055c0 .461-.312.85-.74.968l-.2.056c-.616.175-1.482.421-2.81.421s-2.194-.246-2.81-.42l-.2-.057a1.006 1.006 0 0 1-.74-.968v-.055Zm3.75-16A5.25 5.25 0 0 0 6.75 7v2a5.25 5.25 0 1 0 10.5 0V7c0-2.9-2.35-5.25-5.25-5.25Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgPerson;
